import { React, useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";

import config from '../../store/config';

function EcardAnimation() {
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );
  const currentPreviewState = useSelector((state) => state.cardPreview);

  const requestDetails = currentRequest.DonorRequest;
  const showCardSignature = !requestDetails.DoNotSignCard || requestDetails.CardTypeValue !== "sendtome";
  const showBeginning =
    currentPreviewState.CardMassDate !== "" &&
    requestDetails.OfferingTime === "consecutivedays" &&
    requestDetails.MassQuantity > 1;

    const [cardOpen, setCardOpen] = useState(false);

    const mobileElementRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => setCardOpen(true), 1000);
        return () => {
            setCardOpen(false);
            clearTimeout(timer);
        }
      }, []);

    function toggleCardOpenHandler(openClose) {
        setCardOpen(openClose);

        if(!openClose) {
            mobileElementRef.current.scrollLeft = 0;
        }

        console.log('clicked');
    }

  return (
    <div className="ecard ecard-animation" style={{ transform: `scale(.8)` }}>
      <div className={`cards collection-${config.settings.productCollection}`}>
        <div className="mobile-container">
          <div className="mobile" ref={mobileElementRef}>
            <input
              type="checkbox"
              id="card-toggle-2"
              className="card-toggle"
              value="selected"
              checked={cardOpen}
              onChange={() => {}}
            />
            <label className="card" htmlFor="card-toggle-2" onClick={() => toggleCardOpenHandler(!cardOpen)}>
              <div className="front face">
                <div
                  className="inside-content front-cover"
                  style={{
                    backgroundImage:
                    'url(' + currentPreviewState.SelectedCard.CoverImage + ')',
                  }}
                ></div>
              </div>
              <div className="inner-left face">
                <div
                  className="inside-content inner-left-image"
                  style={{
                    backgroundImage:
                      'url(' + currentPreviewState.SelectedCard.InsideImage + ')',
                  }}
                >
                </div>
              </div>
              <div className="inner-right face">
                <div
                  className="inside-content inner-right-image"
                  style={{
                    backgroundImage:
                    'url(' + currentPreviewState.SelectedCard.InsideImage + ')',
                  }}
                >
                  <div className="inside-text-contain">
                  <div className="service-line-single parse-new-lines">
                    {currentPreviewState.CardHeading}
                  </div>
                  <div
                    className={`intention parse-new-lines ${
                      currentPreviewState.FocusedField === "intention"
                        ? "current-field-focus"
                        : ""
                    }`}
                    style={{ marginTop: "18px", height: "40px" }}
                  >
                    {currentPreviewState.CardIntention}
                  </div>
                  <div
                    className={`sign-as-lines parse-new-lines ${
                      currentPreviewState.FocusedField === "cardSignature"
                        ? "current-field-focus"
                        : ""
                    }`}
                    style={{ marginTop: "332px" }}
                  >
                    {showCardSignature && (
                      <div>{currentPreviewState.CardSignature}</div>
                    )}
                    {!showCardSignature && (
                      <div>
                        <p className="signline">&nbsp;</p>
                        <p className="signline">&nbsp;</p>
                        <p className="signline">&nbsp;</p>
                      </div>
                    )}
                  </div>
                  </div>
                </div>
              </div>
            </label>
          </div>
        </div>
        <button className="btn btn-primary btn-sm ecardLink" type="button" onClick={() => toggleCardOpenHandler(!cardOpen)}>
          {!cardOpen && <span>Open</span>}
          {cardOpen && <span>Close</span>}
        </button>
      </div>
    </div>
  );
}

export default EcardAnimation;
